module.exports = __webpack_public_path__ + "img/home_btn.b23754ca.png";